import { Box, Button, Divider, Flex, Text, VStack, useToast } from "@chakra-ui/react";
import { WarningIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { getHistoricoErrosByProposalId } from "@/services/consignado/proposal-history.service";
import { HistoricoErroPropostaResponseDTO } from "@/services/consignado/dto/proposal-history.dto";

const titulosTipo: Record<string, string> = {
  confirmacao: "Confirmação",
  formalizacao: "Formalização",
  pagamento: "Pagamento",
  cancelamento: "Cancelamento",
  acoes: "Ações",
  averbacao: "Averbação",
};

const formatarData = (data: string | Date): string => {
  const date = typeof data === "string" ? new Date(data) : data;
  const dia = String(date.getDate()).padStart(2, "0");
  const mes = String(date.getMonth() + 1).padStart(2, "0");
  const ano = String(date.getFullYear()).slice(-2);
  const horas = String(date.getHours()).padStart(2, "0");
  const minutos = String(date.getMinutes()).padStart(2, "0");
  return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
};

const formatarTipo = (tipo: string): string =>
  titulosTipo[tipo] || tipo.charAt(0).toUpperCase() + tipo.slice(1);

export function ProposalErrorHistory({ proposalId }: { proposalId: string }) {
  const [isLoading, setIsLoading] = useState(false);
  const [erros, setErros] = useState<HistoricoErroPropostaResponseDTO[]>([]);
  const toast = useToast();

  const handleCarregarErros = async () => {
    setIsLoading(true);
    try {
      const response = await getHistoricoErrosByProposalId(proposalId);
      if (response.length === 0) {
        toast({
          title: "Nenhum erro",
          description: "Não há erros registrados para esta proposta.",
          status: "info",
          duration: 4000,
          isClosable: true,
        });
      } else {
        setErros(response);
      }
    } catch (error) {
      console.error("Erro ao carregar histórico de erros:", error);
      toast({
        title: "Erro ao carregar",
        description: "Não foi possível carregar o histórico de erros.",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  if (erros.length === 0) {
    return (
      <Flex width="100%" justifyContent="center">
        <Button
          bg="#3d5a7f"
          color="white"
          onClick={handleCarregarErros}
          isLoading={isLoading}
          loadingText="Carregando..."
          _hover={{ bg: "#2d4563" }}
        >
          Carregar histórico de erros
        </Button>
      </Flex>
    );
  }

  return (
    <Box width="100%" mt={4}>
      <Text fontWeight="bold" fontSize="lg" color="blue.600" mb={2}>
        Histórico de Erros
      </Text>
      <VStack align="start" spacing={3}>
        {erros.map((erro, index) => (
          <Flex key={index} align="start" gap={2}>
            <WarningIcon color="red.500" boxSize={5} mt={1} />
            <Box>
              <Text fontFamily="Lexend Deca" fontWeight="semibold">
                {formatarData(erro.criado_em)} · {formatarTipo(erro.tipo)} › {erro.item}
              </Text>
              <Text fontFamily="Lexend Deca" whiteSpace="pre-wrap" wordBreak="break-word">
                {erro.mensagem}
              </Text>
            </Box>
          </Flex>
        ))}
      </VStack>
      <Divider mt={2} />
    </Box>
  );
}
